import { SmartLink } from "@selector/shared/components";

import { ENTITY_TYPE } from "@/settings/settings.ts";
import { TruncateTextAutosize } from "@/ui-modules/core/grid/cells/core/TruncateTextAutosize.tsx";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const ParentCell = (props: IAgGridCellProps) => {
  const { value, data, colDef } = props;
  if (colDef.field === undefined) {
    return null;
  }
  // get rid of the ".stringValue" trailer
  const field = colDef.field.substring(0, colDef.field.lastIndexOf("."));
  // The data field is a single-element array (e.g. parents: [{ parent: { id, stringValue } }]).
  // traverseAndCollect (defaultValueGetter) preserves the array structure, so value is string[].
  // Since a sample has exactly one parent, we safely access [0] for both id and display value.
  const id = data?.[field]?.[0].parent?.id;
  return (
    <TableCell>
      <SmartLink to={`/${ENTITY_TYPE.SAMPLE_PARENT}/${id}`}>
        <TruncateTextAutosize text={value[0]} />
      </SmartLink>
    </TableCell>
  );
};

export { ParentCell };
export default ParentCell;
